// components/CustomerType.js
import React, { useState, useEffect } from 'react';
import { TextField, ListItem, ListItemText } from '@mui/material';
import {
  RowContainer,
  BaseLabel,
  AutoComplete,
  Label,
  Input,
  SectionTitle,
  InputHalf,
} from '../../../../styles/styleUtils';
import CampoMonetario from '../../components/CampoMonetario';

import { getGenericData } from '../../../api';

function ProdutoDetail({ formData, onAutoCompleteChange, onInputChange }) {
  const [fornecedor, setFornecedor] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await getGenericData('fornecedor', {});
    setFornecedor(result);
  };

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="Fornecedor">Fornecedor</BaseLabel>
        <AutoComplete
          disablePortal
          id="fornecedor"
          name="fornecedor"
          value={formData.fornecedor || null}
          onChange={(_, value) => onAutoCompleteChange('idFornecedor', 'fornecedor', value)}
          options={fornecedor}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          renderOption={(props, option) => (
            <ListItem key={option._id} {...props}>
              <ListItemText primary={option.nome} secondary={option.razaoSocial} />
            </ListItem>
          )}
          getOptionLabel={(option) => `${option.nome} (${option._id})`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="descricao">Descrição</BaseLabel>
        <Input type="text" id="descricao" name="descricao" value={formData.descricao} onChange={onInputChange} />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="fabricante">Fabricante</BaseLabel>
        <Input type="text" id="fabricante" name="fabricante" value={formData.fabricante} onChange={onInputChange} />
      </RowContainer>
      
      
    </div>
  );
}

export default ProdutoDetail;